import {
  JOIN_PRO_ROUTES,
  PRO_ROUTES,
  TIPAW_STORE_SUPPLEMENTS_URL,
  TIPAW_STORE_URL,
} from '@application/constants';
import type { Route } from '@application/types';
import { useRouter } from '@application/utils';
import { Analytics } from '@application/utils/analytics';
import type {
  StoreBannerSource,
  StoreBannerTheme,
  StoreCardItemPromoSource,
  StoreCardItemPromoType,
} from '@presentation/components';
import { useCallback, useMemo } from 'react';

export const useTipawStore = () => {
  const { infoFromCurrentPath, language, translate } = useRouter();

  const storeUrl = useMemo(() => {
    return TIPAW_STORE_URL[language];
  }, [language]);

  const onStoreHeaderNavbarClick = useCallback(() => {
    Analytics.clickOnStore('header_navigation');
    window.open(storeUrl, '_blank');
  }, [storeUrl]);

  const onStickyBannerClick = useCallback(() => {
    const link = translate('header.stickyBlueBanner.link');
    Analytics.clickOnStore('sticky_banner');
    window.open(link, '_blank');
  }, [translate]);

  const onPromoCardClick = useCallback(
    (type: StoreCardItemPromoType, source: StoreCardItemPromoSource) => {
      const link = translate(`common.storePromoCard.${type}.link`);
      Analytics.clickOnStorePromoCard(type, source);
      window.open(link, '_blank');
    },
    [translate],
  );

  const onBannerClick = useCallback(
    (theme: StoreBannerTheme, source: StoreBannerSource) => {
      Analytics.clickOnStoreBanner(theme, source);
      const url = TIPAW_STORE_SUPPLEMENTS_URL[language];
      window.open(url, '_blank');
    },
    [language],
  );

  const showStickyBanner = useMemo(() => {
    return !([...PRO_ROUTES, ...JOIN_PRO_ROUTES, 'booking'] as Route[]).includes(
      infoFromCurrentPath.route,
    );
  }, [infoFromCurrentPath.route]);

  return {
    storeUrl,
    onStoreHeaderNavbarClick,
    onStickyBannerClick,
    onPromoCardClick,
    showStickyBanner,
    onBannerClick,
  };
};
